@import 'src/styles/common/_colors.scss';
.spinner{
    animation: rotate 3s linear infinite;
	display: flex;
	font-size: 20px;
	color: $green-2;
    margin: 0px 6px;
}

.wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}
.loaderComplete{
	display: flex;
    align-items: center;
	margin-right: 10px;
	color: $green-2;
	> span:first-child{
		margin-right: 4px;
	}
	.enlarged{
		font-weight: 900;
		font-size: 16px;
		vertical-align: middle;
	}
}
.loaderError{
	color: $red-variant-3;
	display: flex;
    align-items: center;
	margin-right: 10px;
}
@keyframes rotate {
	100% {
		transform: rotate(360deg);
	}
}

.loaderDataExceeded{
	display: flex;
    align-items: center;
	margin-right: 10px;
	font-style: italic;
	color:$yellow-varient;
	> span:first-child{
		margin-right: 4px;
	}
}